import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

function Header() {
  const [time, setTime] = useState('');
  const [date, setDate] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      setTime(`${hours}:${minutes}`);

      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const day = dayNames[now.getDay()];
      const dateNum = now.getDate();
      const month = monthNames[now.getMonth()];
      const year = now.getFullYear() - 30;
      setDate(`${day} ${dateNum} ${month} ${year}`);
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error('Error attempting to enable full-screen mode:', err);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <Main>
      <LeftSection>Welcome!</LeftSection>
      <RightSection>

        <IconButton title="Fullscreen" onClick={toggleFullScreen}>⛶ Fullscreen</IconButton>
        <Time>{time}</Time>
        <DateText>{date}</DateText>
      </RightSection>
    </Main>
  );
}

const Main = styled.div`
  font-family: 'dos', monospace;
  font-size: 0.8rem;
  width: 100vw;
 border-top: 3px solid #00a0d0c4;
border-right: 3px solid #00a0d0c4;
border-bottom: 3px solid #00a0d0c4;
border-left: 3px solid #00a0d0c4;
  height:6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0236a9;
  box-shadow: inset 0 -1px 0 #aaa;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  height:100%;
  color:white;  
  font-size: 1rem;
`;
const LeftSection = styled.div`
  padding:8px;
    font-size:2rem;
     display: flex;
  align-items: center;
  justify-content:center;
   border: 3px solid #002457;
   color:#faf14d;
   height:100%;
`;

const IconButton = styled.button`
  background: none;
  color:white;
  border: 3px solid #002457;
  height:100%;
  padding:0px 4px;
  font-family: inherit;
  font-size: 1rem;
  cursor: pointer;
  image-rendering:pixelated;
       display: flex;
  align-items: center;
  justify-content:center;
  &:hover {
    background-color: #054ae1ff;
  }
`;

const Time = styled.span`
    border: 3px solid #002457;
   height:100%;
    padding: 0px 8px;
         display: flex;
  align-items: center;
  justify-content:center;
`;

const DateText = styled.span`
    border: 3px solid #002457;
  height:100%;
   padding:0px 8px;
        display: flex;
  align-items: center;
  justify-content:center;
`;

export default Header;
